export default "__VITE_ASSET__DEbjtwxl__"